import { Link } from 'react-router-dom';

const GETTING_STARTED_ITEMS = [
  {
    icon: '\u{1F3E0}',
    title: 'Analyze a Property',
    description:
      'Create a property analysis with renovation cost estimates, comparable sales, and investment metrics.',
    link: '/analyze/new',
    color: 'var(--primary)',
  },
  {
    icon: '\u{1F4C8}',
    title: 'Calculate a Flip',
    description:
      'Run fix-and-flip analysis numbers with full financing cost modeling and profitability projections.',
    link: '/flip-calculator',
    color: 'var(--success)',
  },
  {
    icon: '\u{1F4E5}',
    title: 'Import a Budget',
    description:
      'Upload a contractor estimate or construction budget to build your benchmark cost database.',
    link: '/import',
    color: '#0891b2',
  },
];

export default function GettingStartedCards() {
  return (
    <div className="getting-started">
      <div className="getting-started-header">
        <span className="getting-started-badge">Getting Started</span>
        <h2 className="getting-started-title">Welcome! Here is how to begin.</h2>
        <p className="getting-started-subtitle">
          Pick one of the actions below to start building your analysis pipeline.
        </p>
      </div>
      <div className="getting-started-grid">
        {GETTING_STARTED_ITEMS.map((item) => (
          <Link
            key={item.link}
            to={item.link}
            className="getting-started-card"
            style={{ '--gs-accent': item.color } as React.CSSProperties}
          >
            <div className="getting-started-card-icon">{item.icon}</div>
            <h3 className="getting-started-card-title">{item.title}</h3>
            <p className="getting-started-card-desc">{item.description}</p>
            <span className="getting-started-card-cta">Get started &rarr;</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
